export default {
    'diagram3b4-3': {
        'diagram-task': 'Inductive',
        'diagram-peak': 'You can teach an old dog new tricks if he is willing and you are patient',
        'diagram-hint': 'How do<br>you know?',
        'diagram-answers': {
          '1': 'Requires that he believe that change is possible (courage)',
          '2': 'Requires that he be willing to do the work (repetitive)',
          '3': 'Requires that he keep at it no matter what (perseverence)',
          '4': 'Post-adolescent brains are never quite so flexible as when we were children',
          '5': 'Requires over coming normal obstacles to learning',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b4/diagram3/i18n/en.js